import styles from './index.module.css'
import Tabs from "../../component/tabs";
const HomeView = ({ children} : any) => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {children}
            </div>
            <div className={styles.bottom}>
                <Tabs/>
            </div>
        </div>
    )
}

export default HomeView;